import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { MessageStatus, MessageStatusTranslations } from 'src/app/core/interfaces/message.interface';

@Pipe({
    name: 'messageStatus',
    pure: false
})
export class MessageStatusPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(value: MessageStatus | string): string {
        if (!value) return '';

        const currentLang = this.localizationService.getCachedLanguage();
        if (currentLang === 'ar') {
            return MessageStatusTranslations[value as MessageStatus] || value;
        }
        return value;
    }
}